import { useEffect, useState } from "react";
import Icon from "./Icon";
import Skeleton from "../Skeleton";
import { loadStats } from "../../stats.js";

const RANGES = [7, 30];

const dayLabel = (date) => date.toLocaleDateString("es-AR", { weekday: "short", day: "numeric" });

// Resumen de estadísticas del Inicio (Pro): visitas por día, pedidos por WhatsApp y productos más vistos.
// En Gratis muestra solo las visitas de la semana como adelanto. El detalle está en StatsPanel.
const StatsCard = ({ business, products, onSeeAll }) => {

    const pro = business.subscribed === true;
    const [days, setDays] = useState(7);
    const [stats, setStats] = useState(null);
    const [failed, setFailed] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [refreshing, setRefreshing] = useState(false);

    // Al cambiar el período se muestra el esqueleto; al actualizar quedan los números
    // anteriores hasta que llegan los nuevos.
    useEffect(() => {
        setStats(null);
    }, [days]);

    useEffect(() => {
        let alive = true;
        setFailed(false);
        loadStats(business.usuarioEmpresa, days)
            .then((list) => alive && setStats(list))
            .catch((error) => {
                console.error(error);
                if (alive) setFailed(true);
            })
            .finally(() => alive && setRefreshing(false));
        return () => { alive = false; };
    }, [business.usuarioEmpresa, days, refreshKey]);

    const refresh = () => {
        setRefreshing(true);
        setRefreshKey((k) => k + 1);
    }

    const visits = stats ? stats.reduce((n, d) => n + d.visitas, 0) : 0;
    const orders = stats ? stats.reduce((n, d) => n + d.pedidos, 0) : 0;
    const views = {};
    (stats || []).forEach((d) => Object.entries(d.vistas).forEach(([id, n]) => { views[id] = (views[id] || 0) + n; }));
    const top = Object.entries(views)
        .map(([id, n]) => ({ product: products.find((p) => p.id === id), n }))
        .filter((t) => t.product)
        .sort((a, b) => b.n - a.n)
        .slice(0, 5);
    const max = Math.max(1, ...(stats || []).map((d) => d.visitas));

  return (
    <section className="lp-panel-card lp-panel-stack lp-panel-wide">
        <div className="lp-panel-card-head">
            <h2>Estadísticas {!pro && <span className="lp-panel-badge">Pro</span>}</h2>
            <div className="lp-panel-range">
                {pro &&
                    <div className="lp-panel-range" role="radiogroup" aria-label="Período">
                        {RANGES.map((r) => (
                            <button key={r} type="button" role="radio" aria-checked={days === r} className={days === r ? "lp-panel-chip lp-panel-chip-on" : "lp-panel-chip"} onClick={() => setDays(r)}>{r} días</button>
                        ))}
                    </div>
                }
                <button type="button" className={"lp-panel-icon-btn lp-panel-refresh" + (refreshing ? " lp-panel-refresh-on" : "")} onClick={refresh} disabled={refreshing} aria-label="Actualizar estadísticas" title="Actualizar">
                    <Icon name="refresh" size={18}></Icon>
                </button>
            </div>
        </div>

        {failed ?
            <p className="lp-panel-muted">No pudimos cargar las estadísticas. Probá de nuevo en un rato.</p> :
        !stats ?
            <Skeleton height={pro ? 180 : 60} radius={12}></Skeleton> :
        !pro ?
            <>
                <p><strong>{visits} {visits === 1 ? "visita" : "visitas"}</strong> a tu menú en los últimos 7 días.</p>
                <p className="lp-panel-muted">Con Pro ves las visitas de cada día, los pedidos por WhatsApp, los carritos abandonados, tus horarios pico, tus productos estrella y mucho más.</p>
                <button type="button" className="lp-btn lp-btn-secondary lp-panel-btn-sm lp-panel-left" onClick={onSeeAll}>
                    Ver todas las estadísticas <Icon name="arrow" size={18}></Icon>
                </button>
            </> :
            <>
                <div className="lp-panel-kpis">
                    <div><strong>{visits}</strong><span className="lp-panel-muted">Visitas</span></div>
                    <div><strong>{orders}</strong><span className="lp-panel-muted">Pedidos por WhatsApp</span></div>
                    <div><strong>{Object.values(views).reduce((a, b) => a + b, 0)}</strong><span className="lp-panel-muted">Productos vistos</span></div>
                </div>

                <div className={"lp-panel-bars" + (days > 7 ? " lp-panel-bars-dense" : "")} role="img" aria-label={`Visitas por día en los últimos ${days} días`}>
                    {stats.map((d) => (
                        <div key={d.date.toISOString()} className="lp-panel-bar" title={`${dayLabel(d.date)}: ${d.visitas} ${d.visitas === 1 ? "visita" : "visitas"}`}>
                            <span className="lp-panel-bar-fill" style={{ height: `${(d.visitas / max) * 100}%` }}></span>
                            {days === 7 && <span className="lp-panel-bar-label">{dayLabel(d.date)}</span>}
                        </div>
                    ))}
                </div>

                <div>
                    <span className="lp-panel-label">Más vistos</span>
                    {top.length ?
                        <ol className="lp-panel-top">
                            {top.map(({ product, n }) => (
                                <li key={product.id}><span>{product.name}</span><strong>{n}</strong></li>
                            ))}
                        </ol> :
                        <p className="lp-panel-muted">Todavía nadie abrió el detalle de un producto en este período.</p>
                    }
                </div>

                <button type="button" className="lp-btn lp-btn-secondary lp-panel-btn-sm lp-panel-left" onClick={onSeeAll}>
                    Ver todas las estadísticas <Icon name="arrow" size={18}></Icon>
                </button>
            </>
        }
    </section>
  )
}

export default StatsCard
